module.exports = __webpack_public_path__ + "img/icon4.621f00d5.png";